export default "__VITE_ASSET__ZaMMCG5F__"